module.exports = __webpack_public_path__ + "img/customer_design_1@2x.58e33ab.webp";